import { graphql } from 'gql'

export const ACTIVATE_ALL_DOMAINS_PRODUCT = graphql(`
  mutation activateAllDomainsProduct($input: ActivateAllDomainsProductInput!) {
    activateAllDomainsProduct(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
